import styled, { createGlobalStyle } from 'styled-components';
import Styled from './Filters.styles';
import { themeColor } from '../theme/colors';
import { baseFont, xxsBold, xxsRegular } from '../theme/typography';
import { Popover } from '@mantine/core';

// this is required for theme-based overrides that are
// specific to this component
const GlobalStyle = createGlobalStyle`
    html[data-mantine-color-scheme="dark"] {
        .flowSelected {
            background: linear-gradient(90deg, #06322E 20.85%, #181A1C 100%);
            box-shadow: 0px 0px 37.9px 0px rgba(19, 191, 174, 0.25);
        }
    }

    html[data-mantine-color-scheme="light"] {
        .flowSelected {
            border: 1px solid #0FE8D3;
            background: linear-gradient(90deg, #EFFFFD 20.85%, #FFF 100%);
            box-shadow: 0px 0px 37.9px 0px rgba(15, 232, 211, 0.25);
        }
    }
`;

const Container = styled(Styled.Container)`
  width: 100%;
  border-radius: 6px;
  background: ${themeColor('buttonBackground')};
  padding: 0;
  gap: 0;
  ${xxsRegular};

  ${baseFont}
  &.flowSelected {
    border: 1px solid ${themeColor('turquoise')};
  }

  .label {
    color: ${themeColor('textPrimary')};
    background-color: ${themeColor('buttonBackground')};
    ${xxsBold};
    padding: 0 20px;
    border-right: 1px solid ${themeColor('strokeLight')};
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    line-height: 36px;
    height: 100%;
    min-width: fit-content;
  }

  .openFilter {
    flex: 1;
    background: transparent;
    border: none;
    text-align: left;
    ${xxsRegular};
    color: ${themeColor('textTertiary')};
    cursor: pointer;
    margin-left: 0;
    line-height: 37px;
  }

  .selectedFlowContainer {
    display: flex;
    color: ${themeColor('textPrimary')};

    .selectedFlowProperty {
      position: relative;
      margin: 0 8px;
      line-height: 35px;

      &:first-child:after {
        content: '';
        position: absolute;
        top: calc(50% - 1px);
        right: -14px;
        width: 4px;
        height: 4px;
        border-radius: 100%;
        background-color: ${themeColor('strokeLight')};
      }
    }

    svg {
      position: relative;
      vertical-align: middle;
      top: 0;
      margin: 0 4px 0 8px;
      color: ${themeColor('gray')};
    }
  }

  .unselectedFlowContainer {
    margin-left: 8px;
  }
`;

const StyledPopover = styled(Popover)`
  text-wrap: nowrap;
`;

const AutoCompleteContainer = styled.div`
  flex: 1;
  margin: 1px 0;

  --mantine-primary-color-filled: ${themeColor('turquoiseTertiary')};

  input {
    background-color: transparent;
    border-radius: 8px;
    margin-bottom: 8px;
  }

  .mantine-Combobox-option {
    color: ${themeColor('textPrimary')};
    ${xxsRegular};
    padding: 2px 0 2px 8px;

    svg {
      position: relative;
      vertical-align: middle;
      top: 0px;
      margin: 0 4px 0 8px;
      color: ${themeColor('gray')};
    }
  }

  .mantine-Combobox-groupLabel {
    margin-top: 8px;
    padding-bottom: 0;
    padding-left: 1px;
  }

  .mantine-Combobox-groupLabel:after {
    display: none;
  }
`;

const ServiceGroupContainer = styled.span`
  color: ${themeColor('textPrimary')};

  svg {
    position: relative;
    vertical-align: middle;
    top: -2px;
    margin: 0 4px 0 0;
    color: ${themeColor('gray')};
  }
`;

const ClearButton = styled(Styled.ClearButton)`
  padding: 0 16px;
  margin-left: auto;
`;

const popoverStyle = {
  '--mantine-spacing-sd': '8px',
  '--mantine-spacing-md': '8px',
  '--popover-border-color': 'transparent',
  maxHeight: '23vw',
  overflow: 'auto',
};

export {
  GlobalStyle,
  Container,
  StyledPopover,
  AutoCompleteContainer,
  ServiceGroupContainer,
  ClearButton,
  popoverStyle,
};
